export type ProgressionState = {
  level: number;
  xp: number;
  xpToNextLevel: number;
  totalXp: number;
};

function xpForLevel(level: number): number {
  return Math.floor(100 * Math.pow(1.5, level - 1));
}

export function createProgressionState(): ProgressionState {
  return {
    level: 1,
    xp: 0,
    xpToNextLevel: xpForLevel(1),
    totalXp: 0,
  };
}

export type LevelUpEvent = {
  newLevel: number;
  oldLevel: number;
};

export function addXp(state: ProgressionState, amount: number): LevelUpEvent[] {
  const events: LevelUpEvent[] = [];
  state.xp += amount;
  state.totalXp += amount;

  while (state.xp >= state.xpToNextLevel) {
    state.xp -= state.xpToNextLevel;
    const oldLevel = state.level;
    state.level++;
    state.xpToNextLevel = xpForLevel(state.level);
    events.push({ newLevel: state.level, oldLevel });
  }

  return events;
}

export const XP_REWARDS = {
  breakBlock: 5,
  placeBlock: 2,
  killMob: 25,
  craftItem: 10,
  discoverBiome: 50,
} as const;
